export const TimeSeriesChartDropdown = [
  { label: "Day", value: "month" },
  { label: "Month", value: "year" },
  { label: "Year", value: "decade" },
];
